module.exports = __webpack_public_path__ + "static/media/attentionWER.b5520fc4.jpg";